import { render, staticRenderFns } from "./InvoiceElementFormEditTab.vue?vue&type=template&id=145e1869&scoped=true"
import script from "./InvoiceElementFormEditTab.vue?vue&type=script&lang=js"
export * from "./InvoiceElementFormEditTab.vue?vue&type=script&lang=js"
import style0 from "./InvoiceElementFormEditTab.vue?vue&type=style&index=0&id=145e1869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e1869",
  null
  
)

export default component.exports